import { COMPONENTS as beforeFinalize } from './beforeFinalize.constant';

export const COMPONENTSX = [...beforeFinalize];
